const mapStyles = [{"featureType":"administrative","elementType":"labels","stylers":[{"saturation":"0"},{"hue":"#006bff"}]},{"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"color":"#041e42"}]},{"featureType":"landscape","elementType":"all","stylers":[{"color":"#d9e1e2"}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"all","stylers":[{"saturation":-100},{"lightness":45}]},{"featureType":"road","elementType":"labels","stylers":[{"visibility":"on"},{"hue":"#006bff"}]},{"featureType":"road","elementType":"labels.text.fill","stylers":[{"hue":"#ff0000"}]},{"featureType":"road.highway","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"road.highway","elementType":"labels.text.fill","stylers":[{"color":"#768692"}]},{"featureType":"road.highway.controlled_access","elementType":"labels.text.fill","stylers":[{"color":"#768692"}]},{"featureType":"road.arterial","elementType":"all","stylers":[{"hue":"#ff0000"}]},{"featureType":"road.arterial","elementType":"geometry.fill","stylers":[{"hue":"#ff0000"}]},{"featureType":"road.arterial","elementType":"labels","stylers":[{"hue":"#ff0000"}]},{"featureType":"road.arterial","elementType":"labels.text.fill","stylers":[{"color":"#768692"}]},{"featureType":"road.arterial","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"road.local","elementType":"labels.text","stylers":[{"hue":"#ff0000"}]},{"featureType":"road.local","elementType":"labels.text.fill","stylers":[{"color":"#768692"}]},{"featureType":"transit","elementType":"all","stylers":[{"visibility":"off"},{"color":"#0039ff"}]},{"featureType":"transit","elementType":"labels.text","stylers":[{"color":"#768692"}]},{"featureType":"water","elementType":"all","stylers":[{"color":"#46bcec"},{"visibility":"on"}]},{"featureType":"water","elementType":"geometry","stylers":[{"visibility":"on"}]},{"featureType":"water","elementType":"geometry.stroke","stylers":[{"hue":"#ff0000"}]},{"featureType":"water","elementType":"labels","stylers":[{"visibility":"on"}]},{"featureType":"water","elementType":"labels.text","stylers":[{"visibility":"on"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#007fa3"},{"visibility":"on"}]},{"featureType":"water","elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"}]}];

class SingleMap  {
	
	constructor() {
		this.mapEvents();
	}

	mapEvents() {
		if( $(".am-single-map--active").length > 0 ) {
			var self = this;
			$(".am-single-map").each(function(){
				var mapId = $(this).data('map-id');
				var coords = {
					lat: $(this).data('lat'),
					lng: $(this).data('lng'),
				}
				self.initMap(coords, mapId);
			})

		}
	}

	initMap(coords, mapId) {

		var mapEls = document.getElementsByClassName(`am-single-map--${mapId}`);
		var mapEl = mapEls[0];
		var image = { 
			 url: `${BJZM_DATA.assets_url}/zibi_pin.png`,
			 scaledSize: new google.maps.Size(31,41)
		};

		var map = new google.maps.Map(mapEl, {
			zoom: 15,
			center: coords,
			center: new google.maps.LatLng(coords.lat, coords.lng),
			styles: mapStyles,
			scrollwheel: false,
			mapTypeControl: false,
			rotateControl: false,
			fullscreenControl: false,
			streetViewControl: false
		});

		var marker = new google.maps.Marker({
			position: coords,
			map: map
		});

		marker.setIcon(image);

	}

}


module.exports = SingleMap;